import axios from "axios";

const apiClient = axios.create({
  baseURL: 'https://adressevaelger.dk',
  withCredentials: false,
  headers: { Accept: "application/json" }
});

const adressevaelgerToken = "adressevaelger123";

function toExistingAddressFormat(result) {
  const title = result.titel || result.adressebetegnelse || "";
  const addressMatch = title.match(/^(.*?)\s+(\d+[A-Za-z]?(?:[-/]\d+)?)(?:,\s*(.*?))?,\s*(\d{4})\s+(.+)$/);
  let floor = "";
  let door = "";

  if (addressMatch && addressMatch[3]) {
    const floorAndDoor = addressMatch[3].trim();
    const floorAndDoorMatch = floorAndDoor.match(/^(\d+)\.\s*(.+)$/);
    if (floorAndDoorMatch) {
      floor = floorAndDoorMatch[1];
      door = floorAndDoorMatch[2];
    } else {
      const groundFloorAndDoorMatch = floorAndDoor.match(/^(st\.?)\s+(.+)$/i);
      if (groundFloorAndDoorMatch) {
        floor = groundFloorAndDoorMatch[1];
        door = groundFloorAndDoorMatch[2];
      } else if (/^st\.?$/i.test(floorAndDoor)) {
        floor = floorAndDoor;
      }
    }
  }

  const address = addressMatch
    ? {
        vejnavn: addressMatch[1],
        husnr: addressMatch[2],
        etage: floor,
        dør: door,
        postnr: addressMatch[4],
        postnrnavn: addressMatch[5]
      }
    : {
        vejnavn: result.vejnavn || "",
        husnr: "",
        etage: "",
        dør: "",
        postnr: result.postnr || "",
        postnrnavn: result.postdistrikt || ""
      };

  return {
    tekst: title,
    type: addressMatch ? "adresse" : result.type === "husnummer" ? "husnummer" : "vejnavn",
    data: {
      ...address,
      husnr: address.husnr || result.husnummer || "",
      id: result.id
    }
  };
}

export const DawaService = {
  async getAccessAddressById(id) {
    return await apiClient.get(`/adgangsadresser/${id}`);
  },
  async getAddressById(id) {
    return await apiClient.get(`/adresser/${id}`);
  },

  async addressLookup(query, type) {
    const response = await apiClient.get("/adresser/soeg", {
      params: {
        tekst: query,
        token: adressevaelgerToken,
        max: 200
      }
    });

    return (response.data.fund || []).map(toExistingAddressFormat);
  },

  async getAllZipcode() {
    return await apiClient.get(`/postnumre`);
  }
};
